import { StylePropertyDefinition } from '../../types/common';

export const styleProperties: Array<StylePropertyDefinition> = [];

export const styleDefaults = new Map<string, string>();

export const stylePropertiesForTheme: Array<StylePropertyDefinition> = [
	{
		cp: 'gap',
		sel: '.comp.compRadioButton<designType><colorScheme>',
		np: true,
		gn: 'Gap',
		dn: 'Gap',
		n: 'radioButtonGap<designType><colorScheme>',
		dv: '5px',
	},
	{
		cp: 'color',
		sel: '.comp.compRadioButton<designType><colorScheme>',
		np: true,
		spv: {
			'_outlined-_primary': '<fontColorThree>',
			'_outlined-_secondary': '<fontColorFour>',
			'_outlined-_tertiary': '<fontColorFive>',
			'_outlined-_quaternary': '<fontColorNine>',
			'_outlined-_quinary': '<fontColorSeven>',
		},
		gn: 'Color',
		dn: 'Color',
		n: 'radioButtonColor<designType><colorScheme>',
	},
	{
		cp: 'box-shadow',
		sel: '.comp.compRadioButton<designType><colorScheme> label._selected',
		np: true,
		gn: 'Box Shadow',
		dn: 'BoxShadow Selected',
		n: 'radioButtonBoxShadowSelected<designType><colorScheme>',
	},
	{
		cp: 'border',
		sel: '.comp.compRadioButton<designType><colorScheme> .commonCheckbox',
		np: true,
		spv: {
			'_default-': 'none',
			'_outlined-': '2px solid',
		},
		gn: 'Border',
		dn: 'Border CommonCheckbox',
		n: 'radioButtonBorderCommonCheckbox<designType><colorScheme>',
	},
	{
		cp: 'border-color',
		sel: '.comp.compRadioButton<designType><colorScheme> .commonCheckbox',
		np: true,
		spv: {
			'_outlined-_primary': '<fontColorThree>',
			'_outlined-_secondary': '<fontColorFour>',
			'_outlined-_tertiary': '<fontColorFive>',
			'_outlined-_quaternary': '<fontColorNine>',
			'_outlined-_quinary': '<fontColorSeven>',
		},
		gn: 'Border Color',
		dn: 'BorderColor CommonCheckbox',
		n: 'radioButtonBorderColorCommonCheckbox<designType><colorScheme>',
	},
	{
		cp: 'background',
		sel: '.comp.compRadioButton<designType><colorScheme> .commonCheckbox',
		np: true,
		spv: {
			'_default-_primary': '<backgroundColorOne>',
			'_default-_secondary': '<backgroundColorTwo>',
			'_default-_tertiary': '<backgroundColorThree>',
			'_default-_quaternary': '<backgroundColorFour>',
			'_default-_quinary': '<backgroundColorFive>',
			'_outlined-': '<backgroundColorSeven>',
		},
		gn: 'Background',
		dn: 'Background CommonCheckbox',
		n: 'radioButtonBackgroundCommonCheckbox<designType><colorScheme>',
	},
	{
		cp: 'background',
		sel: '.comp.compRadioButton<designType><colorScheme> .commonCheckbox ._thumb',
		np: true,
		spv: {
			'_default-': '<backgroundColorSeven>',
			'_outlined-_primary': '<fontColorThree>',
			'_outlined-_secondary': '<fontColorFour>',
			'_outlined-_tertiary': '<fontColorFive>',
			'_outlined-_quaternary': '<fontColorNine>',
			'_outlined-_quinary': '<fontColorSeven>',
		},
		gn: 'Background',
		dn: 'Background Thumb',
		n: 'radioButtonBackgroundThumb<designType><colorScheme>',
	},
	{
		cp: 'border-color',
		sel: '.comp.compRadioButton<designType><colorScheme> .commonCheckbox._checked',
		np: true,
		gn: 'Border Color',
		dn: 'BorderColor Checked',
		n: 'radioButtonBorderColorChecked<designType><colorScheme>',
	},
	{
		cp: 'background',
		sel: '.comp.compRadioButton<designType><colorScheme> .commonCheckbox._disabled ._thumb',
		np: true,
		spv: {
			'_outlined-': '<fontColorEight>',
		},
		gn: 'Background',
		dn: 'Background Disabled Thumb',
		n: 'radioButtonBackgroundDisabledThumb<designType><colorScheme>',
	},
	{
		cp: 'border-color',
		sel: '.comp.compRadioButton<designType><colorScheme> .commonCheckbox._disabled',
		np: true,
		spv: {
			'_outlined-': '<fontColorEight>',
		},
		gn: 'Border Color',
		dn: 'BorderColor Disabled',
		n: 'radioButtonBorderColorDisabled<designType><colorScheme>',
	},
	{
		cp: 'background',
		sel: '.comp.compRadioButton<designType><colorScheme> .commonCheckbox._disabled',
		np: true,
		spv: {
			'_default-': '<backgroundColorEight>',
		},
		gn: 'Background',
		dn: 'Background Disabled',
		n: 'radioButtonBackgroundDisabled<designType><colorScheme>',
	},
	{
		cp: 'font',
		sel: '.comp.compRadioButton<designType><colorScheme> label',
		np: true,
		spv: {
			'_default-': '<primaryFont>',
			'_outlined-': '<primaryFont>',
		},
		gn: 'Font',
		dn: 'Font',
		n: 'radioButtonFont<designType><colorScheme>',
	},
	{
		cp: 'width',
		sel: '.comp.compRadioButton<designType><colorScheme> label',
		np: true,
		gn: 'Width',
		dn: 'Width',
		n: 'radioButtonWidth<designType><colorScheme>',
	},
	{
		cp: 'height',
		sel: '.comp.compRadioButton<designType><colorScheme> label',
		np: true,
		gn: 'Height',
		dn: 'Height',
		n: 'radioButtonHeight<designType><colorScheme>',
	},
	{
		cp: 'border-radius',
		sel: '.comp.compRadioButton<designType><colorScheme> label',
		np: true,
		gn: 'Border Radius',
		dn: 'BorderRadius',
		n: 'radioButtonBorderRadius<designType><colorScheme>',
	},
	{
		cp: 'border',
		sel: '.comp.compRadioButton<designType><colorScheme> label',
		np: true,
		gn: 'Border',
		dn: 'Border',
		n: 'radioButtonBorder<designType><colorScheme>',
	},
	{
		cp: 'padding',
		sel: '.comp.compRadioButton<designType><colorScheme> label',
		np: true,
		gn: 'Padding',
		dn: 'Padding',
		n: 'radioButtonPadding<designType><colorScheme>',
	},
	{
		cp: 'color',
		sel: '.comp.compRadioButton<designType><colorScheme> label._disabled',
		np: true,
		spv: {
			'_outlined-': '<fontColorEight>',
		},
		gn: 'Color',
		dn: 'Color Disabled',
		n: 'radioButtonColorDisabled<designType><colorScheme>',
	},
	{
		cp: 'border-color',
		sel: '.comp.compRadioButton<designType><colorScheme> label._selected',
		np: true,
		gn: 'Border Color',
		dn: 'BorderColor Selected',
		n: 'radioButtonBorderColorSelected<designType><colorScheme>',
	},
];
